/**
 * Hook Lazysizes Plugin into Flickity
 */
/* eslint-disable no-underscore-dangle */
const Flickity = require('flickity');

Flickity.createMethods.push('_createPluginMdsLazySizes');

const proto = Flickity.prototype;
// eslint-disable-next-line func-names
proto._createPluginMdsLazySizes = function () {
  this.element.addEventListener('lazyloaded', () => {
    this.resize();
  });
};
